const queryString = window.location.search;
const domain = "https://solvil-et-titus-malaysia-5bd10f2f4aae8c3364e6.o2.myshopify.dev";
if (queryString) {
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.get('checkout_url')) {
    window.location.href = domain + "/home/solvil-et-titus-malaysia?return=/checkout"
  } else {
    window.location.href = domain + "/home/solvil-et-titus-malaysia"
  }
} else {
  window.location.href = domain + "/home/solvil-et-titus-malaysia"
}